import React, { useEffect } from "react"

import DesktopMenu from "./deskTopMenu"
import MobileMenu from "./mobileMenu"

import './menu.css'

import logo from '../../../images/new-logo.png'
import { AppBar } from "@mui/material"

const MenuList = [
    [
        'About', // title
        '/#about', // Link
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Roadmap',
        '/#roadmap',
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Docs',
        'https://metasnooker.medium.com/',
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Docs',
        '/#', 
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Whitepaper',
        'https://metasnooker.io/white-paper.pdf',
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Rewards',
        'https://metasnooker.io/rewards',
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'VR',
        'https://metasnooker.io/VR/',
        'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
    ]
];
// [
//     'VR Demo',
//     'https://metasnooker.io/vr',
//     'Global---menu-link px-2 px-lg-5 py-1 mx-1', // Class for Desktop
//     'Global---menu-link px-3 py-2 mx-3 pr-5' // Class for Mobile
// ]
const Menu = () => {
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
    const isSticky = (e) => {
        const header = document.querySelector('.Globle---menu-section');
        const scrollTop = window.scrollY;
        scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    };
    return(
        <div className="Globle---menu-section" style={{backgroundColor: '#060514'}}>
        {/* <AppBar position="fixed" style={{backgroundColor: '060514',boxShadow: 'unset'}}> */}
            
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        {/* </AppBar> */}
        </div>
    )
}

export default Menu;